export default {
  en: {
    Questions: 'Questions',
    questions: {
      tryfree: 'Try today for free!',
      answered: 'Answered',
      total: 'Total',
      positive: 'Positive',
      seen: 'Questions seen and answered',
      solvedpositively: 'Questions solved positively',
      completions: 'Completions',
      askedin: 'Question asked in',
      page: {
        title: 'License Catalogs',
        text: 'Here you find all the questions you can practice. You can start with any of the licenses and categories, but we recommend you to start and stick with the one you want to get the license for.'
      },
      licensepage: {
        exampreparation: {
          title: '{license} - Exam Preparation',
          description: 'Prepare for your exam with a simulated exam that uses a random selection of questions from the question pool. This will help you get familiar with the exam format and identify areas where you may need to focus your study efforts.'
        }
      },
      questionpage: {
        notloaded: 'Question not loaded',
        hint: 'Hint',
        skip: 'Skip',
        validate: 'Validate',
        next: 'Next',
        forkeyboard: 'For keyboard operation, select the number key of the chosen answer.',
        enter: 'Enter to validate',
        escape: 'Escape to clear',
        arrows: 'Arrows to navigate',
        finish: 'Finish',
        back: 'Back',
      }
    }
  },
  de: {
    Questions: 'Fragen',
    questions: {
      tryfree: 'Heute kostenlos testen!',
      answered: 'Beantwortet',
      total: 'Insgesamt',
      positive: 'Positiv',
      seen: 'Fragen gesehen und beantwortet',
      solvedpositively: 'Fragen positiv beantworted',
      completions: 'Abschlüsse',
      askedin: 'Frage gestellt in',
      page: {
        title: 'Lizenzkataloge',
        text: 'Hier finden Sie alle Fragen, die Sie üben können. Sie können mit einer beliebigen Lizenz und Kategorie beginnen, aber wir empfehlen Ihnen, mit derjenigen zu beginnen und dabei zu bleiben, für die Sie die Lizenz erhalten möchten.'
      },
      licensepage: {
        exampreparation: {
          title: '{license} - Prüfungsvorbereitung',
          description: 'Bereiten Sie sich mit einer simulierten Prüfung, die eine zufällige Auswahl von Fragen aus dem Fragenpool verwendet, auf Ihre Prüfung vor. Dies hilft Ihnen, sich mit dem Prüfungsformat vertraut zu machen und Bereiche zu identifizieren, auf die Sie sich bei Ihren Studienbemühungen konzentrieren müssen.'
        }
      },
      questionpage: {
        notloaded: 'Frage nicht geladen',
        hint: 'Tipp',
        skip: 'Überspringen',
        validate: 'Validieren',
        next: 'Nächste',
        forkeyboard: 'Für die Tastaturbedienung wählen Sie die Zahlentaste der gewählten Antwort.',
        enter: 'Eingabetaste zum Validieren',
        escape: 'Escape zum Löschen',
        arrows: 'Pfeile zur Navigation',
        finish: 'Beenden',
        back: 'Zurück',
      }
    }
  },
  es: {
    Questions: 'Preguntas',
    questions: {
      tryfree: '¡Pruébalo hoy gratis!',
      answered: 'Respondidas',
      total: 'Total',
      positive: 'Positivas',
      seen: 'Preguntas vistas y respondidas',
      solvedpositively: 'Preguntas resueltas positivamente',
      completions: 'Completaciones',
      askedin: 'Pregunta realizada en',
      page: {
        title: 'Catálogos de licencias',
        text: 'Aquí encontrarás todas las preguntas que puedes practicar. Puedes comenzar con cualquiera de las licencias y categorías, pero te recomendamos que comiences y te mantengas con la que desees obtener la licencia.'
      },
      licensepage: {
        exampreparation: {
          title: '{license} - Preparación para el examen',
          description: 'Prepárate para tu examen con un examen simulado que utiliza una selección aleatoria de preguntas del banco de preguntas. Esto te ayudará a familiarizarte con el formato del examen e identificar áreas en las que puedas necesitar enfocar tus esfuerzos de estudio.'
        }
      },
      questionpage: {
        notloaded: 'Pregunta no cargada',
        hint: 'Pista',
        skip: 'Saltar',
        validate: 'Validar',
        next: 'Siguiente',
        forkeyboard: 'Para la operación del teclado, seleccione la tecla numérica de la respuesta elegida.',
        enter: 'Enter para validar',
        escape: 'Escape para borrar',
        arrows: 'Flechas para navegar',
        finish: 'Finalizar',
        back: 'Atrás',
      }
    }
  },
  uk: {
    Questions: 'Питання',
    questions: {
      tryfree: 'Спробуйте сьогодні безкоштовно!',
      answered: 'Відповіли',
      total: 'Всього',
      positive: 'Позитивні',
      seen: 'Питання переглянуті та відповіли',
      solvedpositively: 'Питання вирішені позитивно',
      completions: 'Завершення',
      askedin: 'Питання задано в',
      page: {
        title: 'Каталоги ліцензій',
        text: 'Тут ви знайдете всі питання, які ви можете вивчити. Ви можете почати з будь-якої з ліцензій та категорій, але ми радимо вам почати та залишатися з тією, для якої ви хочете отримати ліцензію.'
      },
      licensepage: {
        exampreparation: {
          title: '{license} - Підготовка до іспиту',
          description: 'Підготуйтеся до іспиту за допомогою імітованого іспиту, який використовує випадковий вибір питань із банку питань. Це допоможе вам ознайомитися з форматом іспиту та визначити сфери, на яких вам можливо потрібно зосередити свої зусилля щодо навчання.'
        }
      },
      questionpage: {
        notloaded: 'Питання не завантажено',
        hint: 'Підказка',
        skip: 'Пропустити',
        validate: 'Підтвердити',
        next: 'Наступне',
        forkeyboard: 'Для роботи з клавіатурою виберіть числову клавішу обраної відповіді.',
        enter: 'Enter для підтвердження',
        escape: 'Escape для очищення',
        arrows: 'Стрілки для навігації',
        finish: 'Завершити',
        back: 'Назад',
      }
    }
  },
}
